import { useState, useEffect, useRef, useContext } from 'react';
import { useRouter } from 'next/router';
import { useViewport } from 'hooks/3catinfo/useViewport';
import { HistoryContext } from 'context/3catinfo/HistoryProvider';
import Boto from 'components/3catinfo/Boto';
import Imatge from 'components/3catinfo/Imatge';
import Icona from 'components/3catinfo/ui/Icona';
import clsx from 'clsx';
import styles from './joc.module.scss';

const MobileInitScreen = (props) => {
    const { onClick, imatges } = props;

    return (
        <div className={styles.contentInitMobile}>
            <div className={styles.imatgeMobileWrapper}>
                <Imatge
                    imatges={imatges}
                    tipus='web_destacat_horitzontal'
                    aria-hidden='true'
                    layout='fill'
                    objectFit='cover'
                    className={styles.imatgeMobile}
                />
            </div>
            <Boto tag='button' text='Juga ara' className={styles.btn} mida='s' onClick={onClick} />
        </div>
    );
};

const GameScreen = (props) => {
    const { data, estil = 'default', fullscreen } = props;
    const iframeRef = useRef(null);

    const stylesJoc = clsx({
        [styles.innerJoc]: true,
        [styles.fullscreen]: fullscreen,
        [styles[estil]]: estil
    });

    return (
        <>
            <div className={styles.contentJoc}>
                <div className={stylesJoc}>
                    <div ref={iframeRef} dangerouslySetInnerHTML={{ __html: data }} />
                </div>
            </div>
        </>
    );
};

const Joc = (props) => {
    const { imatges } = props;
    const { isMobile } = useViewport();
    const initTimerMobile = useRef(null);
    const [content, setContent] = useState(<></>);
    const { hasVisited } = useContext(HistoryContext);
    const router = useRouter();
    const paginaAnterior = useRef(hasVisited('/3catinfo/jocs/'));

    const handleCloseFullScreen = () => {
        if (paginaAnterior.current && isMobile) {
            router.push('/3catinfo/jocs/');
        } else {
            setContent(
                <MobileInitScreen
                    onClick={() =>
                        setContent(<GameScreen {...props} fullscreen={true} onCloseFullscreen={handleCloseFullScreen} />)
                    }
                    imatges={imatges}
                />
            );
        }
    };

    const setMobileScreen = () => {
        setContent(
            <MobileInitScreen
                onClick={() => setContent(<GameScreen {...props} fullscreen={true} onCloseFullscreen={handleCloseFullScreen} />)}
                imatges={imatges}
            />
        );
    };

    useEffect(() => {
        const initTimerMobileCurrent = initTimerMobile?.current;
        if (isMobile && !paginaAnterior.current) {
            setMobileScreen();
        } else {
            setContent(
                <GameScreen
                    {...props}
                    fullscreen={paginaAnterior.current && isMobile}
                    onCloseFullscreen={handleCloseFullScreen}
                />
            );
        }
        return () => clearTimeout(initTimerMobileCurrent);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile]);

    return content;
};

export default Joc;
